import { visitRecordConstants } from "@constants";
import { constructionService, visitRecordService } from "@services";
import { constructionActions, maskActions } from "@actions";
import { msgTypes, showModal } from "@utils";

export const visitRecordActions = {
  /**
   * 取得訪客紀錄列表
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: visitRecordConstants.GET_ALL_REQUEST
      });

      visitRecordService.getAll(constructionUuid, condition).then(
        ({ items, statistics, total }) => {
          dispatch({
            type: visitRecordConstants.GET_ALL_SUCCESS,
            constructionUuid,
            items,
            statistics,
            total,
            condition
          });
        },
        error => {
          dispatch({
            type: visitRecordConstants.GET_ALL_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重置訪客紀錄列表
   * @returns
   */
  resetAll: () => ({
    type: visitRecordConstants.RESET_ALL_SUCCESS
  }),
  /**
   * 新增訪客紀錄資訊
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 訪客紀錄資訊
   * @param {function} cbSuccess - 成功後的 callback
   *
   * @returns
   */
  create: (constructionUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      visitRecordService
        .create(constructionUuid, info)
        .then(
          response => {
            dispatch(constructionActions.getSummaries(constructionUuid));
            cbSuccess && cbSuccess();
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 取得訪客紀錄資訊
   * @param {number} id - 訪客紀錄 id
   * @param {function} cbSuccess - 成功後的 callback
   * @param {function} cbError - 失敗後的 callback
   * @returns
   */
  getEdited: (id, cbSuccess, cbError) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      visitRecordService
        .get(id)
        .then(
          visitRecord => {
            const transferedVisitRecord = {
              ...visitRecord,
              visit_target: !!visitRecord.household_id ? "household" : "other",
              count_other: visitRecord.count > 5 ? visitRecord.count : null
            };

            cbSuccess && cbSuccess(transferedVisitRecord);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error, cbError);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 更新訪客紀錄資訊
   * @param {number} id - 訪客紀錄 id
   * @param {object} info - 訪客紀錄資訊
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  update: (id, info, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      visitRecordService
        .update(id, info)
        .then(
          response => {
            showModal(msgTypes.SUCCESS, "通知", response, cbSuccess);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 刪除訪客紀錄資訊
   * @param {number} id - 訪客紀錄 id
   * @param {string} constructionUuid - 建案 uuid
   * @returns
   */
  delete: (id, constructionUuid) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      visitRecordService
        .delete(id)
        .then(
          response => {
            dispatch(constructionActions.getSummaries(constructionUuid));
            showModal(msgTypes.SUCCESS, "通知", response, () => {
              visitRecordActions.__getAll(dispatch, getState);
            });
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  __getAll: (dispatch, getState) => {
    const { visitRecords } = getState();
    dispatch(
      visitRecordActions.getAll(
        visitRecords?.query?.constructionUuid,
        visitRecords?.query?.condition
      )
    );
  },
  /**
   * 取得拜訪原因選項清單
   * @returns
   */
  getReasonOptions: () => {
    return dispatch => {
      dispatch({
        type: visitRecordConstants.GET_REASON_OPTIONS_REQUEST
      });

      constructionService.getOperateOptionList("visit_reason").then(
        reasonOptions => {
          dispatch({
            type: visitRecordConstants.GET_REASON_OPTIONS_SUCCESS,
            reasonOptions
          });
        },
        error => {
          dispatch({
            type: visitRecordConstants.GET_REASON_OPTIONS_FAILURE,
            error
          });
        }
      );
    };
  },
  /**
   * 重置拜訪原因選項清單
   * @returns
   */
  resetReasonOptions: () => ({
    type: visitRecordConstants.RESET_REASON_OPTIONS_SUCCESS
  }),
  /**
   * 訪客離場
   * @param {number} id - 訪客紀錄 id
   * @param {string} constructionUuid - 建案 uuid
   * @returns
   */
  left: (id, constructionUuid) => {
    return (dispatch, getState) => {
      dispatch(maskActions.toggleMask(true));
      visitRecordService
        .left(id)
        .then(
          response => {
            dispatch(constructionActions.getSummaries(constructionUuid));
            showModal(msgTypes.SUCCESS, "通知", response, () => {
              visitRecordActions.__getAll(dispatch, getState);
            });
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  }
};
